import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import Privacy from './pages/Privacy';
import Terms from './pages/Terms';
import Safety from './pages/Safety';
import Support from './pages/Support';
import Help from './pages/Help';
import './App.css';
import Download from './pages/Download';
import ChildSafety from './pages/ChildSafety';
import AccountDeletion from './pages/AccountDeletion';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/help" element={<Help />} />
        <Route path="/support" element={<Support />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/safety" element={<Safety />} />
        <Route path="/terms" element={<Terms />} />
        <Route path='/download' element={<Download />} />
        <Route path="/child-safety" element={<ChildSafety />} />
        <Route path='/account-deletion' element={<AccountDeletion />} />
      </Routes>
    </Router>
  );
}

export default App;
